import { render, staticRenderFns } from "./item-info-vr.vue?vue&type=template&id=3d780402&scoped=true"
import script from "./item-info-vr.vue?vue&type=script&lang=js"
export * from "./item-info-vr.vue?vue&type=script&lang=js"
import style0 from "./item-info-vr.vue?vue&type=style&index=0&id=3d780402&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d780402",
  null
  
)

export default component.exports